import { useState } from "react";
import { getPreference, iGridColumn } from "../../../interfaces/preference";
import "./styles.css";
import React from "react";
import { iEnquiry } from "../../../interfaces/iEnquiry";
import { dataColumn } from "../DataTable";
export interface gProps {
    cols: dataColumn<iEnquiry>[];
    saveCols: (cols: dataColumn<iEnquiry>[]) => void;
}
const Grid = (props: gProps) => {
    const [rows, setRows] = useState<dataColumn<iEnquiry>[]>([]);

    React.useEffect(() => {
        setRows(props.cols);
    }, []);

    const dragItem = React.useRef<number | null>(null);
    const dragOverItem = React.useRef<number | null>(null);
    const handleDragStart = (e: React.DragEvent<HTMLTableRowElement>, index: number) => {
        if (index > 3) {
            dragItem.current = index;
        }
    };

    const handleDragEnter = (e: React.DragEvent<HTMLTableRowElement>, index: number) => {
        dragOverItem.current = index;
    };

    const handleDrop = () => {
        if (dragItem.current !== null && dragOverItem.current !== null && dragOverItem.current > 3) {
            const copyListItems = [...rows];
            const dragItemContent = copyListItems[dragItem.current];
            copyListItems.splice(dragItem.current, 1);
            copyListItems.splice(dragOverItem.current, 0, dragItemContent);
            dragItem.current = null;
            dragOverItem.current = null;
            setRows(copyListItems);
            props.saveCols(copyListItems);
        }
    };
    const updateWidthVal = (evt: any) => {
        if (!isNaN(evt.currentTarget.value)) {
            const copyListItems = [...rows];
            let currentCol = copyListItems.find(x => x.key == evt.currentTarget.id);
            if (currentCol) {
                copyListItems.find(x => x.key == evt.currentTarget.id)!.width = evt.currentTarget.value + "px";
                setRows(copyListItems);
                props.saveCols(copyListItems);
            }
        }
    };
    const updateVisibleVal = (evt: any) => {
        const copyListItems = [...rows];
        copyListItems.find(x => x.key == evt.currentTarget.id.replace("ch_", ""))!.visible = evt.currentTarget.checked;
        setRows(copyListItems);
        props.saveCols(copyListItems);
    };
    return (
        <table className="gridWrapper">
            <tr className="gridHeader">
                <th>Column Name</th>
                <th>Width</th>
                <th>Visble</th>
            </tr>
            {rows.map((x, index) => {
                return (
                    <tr
                        className={x.key == "verticalSPacer" ? "gridRowNotVisible" : "gridRow"}
                        draggable={x.key != "verticalSPacer" ? true : false}
                        onDragStart={e => handleDragStart(e, index)}
                        onDragEnter={e => handleDragEnter(e, index)}
                        onDragEnd={handleDrop}
                        onDragOver={e => e.preventDefault()}
                    >
                        <td>{x.title}</td>
                        <td>
                            <input
                                type="number"
                                value={x.width.replace("px", "")}
                                onChange={updateWidthVal}
                                id={x.key}
                                style={{ width: "50px", marginRight: "5px" }}
                                disabled={
                                    x.key == "verticalSPacer" ||
                                    x.key == "priority" ||
                                    x.key == "hasUnworkedAttachments" ||
                                    x.key == "hasAlarm"
                                        ? true
                                        : false
                                }
                            />
                            px
                        </td>
                        <td>
                            <input
                                type="checkbox"
                                className="g-Checkbox-default"
                                id={"ch_" + x.key}
                                checked={x.visible == true ? true : false}
                                onChange={updateVisibleVal}
                                disabled={
                                    x.key == "verticalSPacer" ||
                                    x.key == "priority" ||
                                    x.key == "hasUnworkedAttachments" ||
                                    x.key == "hasAlarm"
                                        ? true
                                        : false
                                }
                            ></input>
                        </td>
                    </tr>
                );
            })}
        </table>
    );
};

export default Grid;
